import React from "react";
import { Table, Button } from "semantic-ui-react";
import BotonBorrar from "../../../shared/botones/BotonBorrar";

function Fila(props) {
  const handleClick = () => props.handleClick(props.idInscripcion);
  const handleFormaDePago = () => props.handleFormaDePago(props.idInscripcion);

  return [
    <Table.Row key={props.idInscripcion} className="aristas-pointer">
      <Table.Cell onClick={handleClick} content={props.nombre} />
      <Table.Cell onClick={handleClick} content={props.apellido1} />
      <Table.Cell
        onClick={handleClick}
        content={props.edad}
        textAlign="center"
      />
      <Table.Cell onClick={handleClick} content={props.telefonos} />
      <Table.Cell
        onClick={handleClick}
        content={props.servicios}
        textAlign="center"
      />

      <Table.Cell textAlign="center">
        <Button
          content={props.formaDePago.toUpperCase()}
          color={
            props.formaDePago === "efectivo"
              ? "green"
              : props.formaDePago === "transferencia"
                ? "blue"
                : props.formaDePago === "desconocida"
                  ? "red"
                  : "grey"
          }
          onClick={handleFormaDePago}
        />
      </Table.Cell>

      <Table.Cell textAlign="center">
        {props.matinal && props.vespertina
          ? "MyV"
          : props.matinal
            ? "Matinal"
            : props.vespertina
              ? "Vespertina"
              : "-"}
      </Table.Cell>

      <Table.Cell collapsing textAlign="center">
        <BotonBorrar
          data={{ idInscripcion: props.idInscripcion }}
          handleClick={props.handleBorrarLinea}
          headerText={`Borrar de la lista`}
          content={`¿Desea eliminar a ${props.nombre} ${
            props.apellido1
          } de la lista?`}
          floated={null}
        />
      </Table.Cell>
    </Table.Row>,
    <Table.Row key={`${props.idInscripcion}sub`} warning>
      <Table.Cell colSpan={12} content={props.notas} />
    </Table.Row>
  ];
}

export default Fila;



// WEBPACK FOOTER //
// ./src/pages/inscripcionesConfirmadas/listaInscripciones/tabla/Fila.jsx